import { useCallback, useMemo } from 'react'
import { useQuery } from '@sequencehq/api'
import { dashboardv20240509Client } from '@sequencehq/api/dashboard/v20240509'
import { MINUTES } from '@sequencehq/utils/dates'
import { Integration } from 'modules/Customers/types'

export const useFetchIntegrations = () => {
  const query = useQuery(dashboardv20240509Client.getIntegrations, undefined, {
    staleTime: 1 * MINUTES
  })

  const integrations: Integration[] | null = query.data?.items ?? null

  const connectedIntegrations = useMemo(
    () =>
      integrations?.filter(
        integration => integration.enabled && integration.state === 'CONNECTED'
      ),
    [integrations]
  )

  const queryRefetch = query.refetch
  const refetch = useCallback(async () => {
    await queryRefetch()
  }, [queryRefetch])

  return {
    integrations,
    connectedIntegrations,
    loading: query.isPending,
    error: Boolean(query.error),
    refetch
  }
}
